import { InjectionToken } from '@angular/core';
import * as Ably from 'ably';

export type AblyRealtimeConstructor = new (
	options: Ably.ClientOptions,
) => Ably.Realtime;

export const ABLY_REALTIME = new InjectionToken<AblyRealtimeConstructor>(
	'AblyRealtimeConstructor',
	{
		providedIn: 'root',
		factory: () => Ably.Realtime,
	},
);
